// extracted by mini-css-extract-plugin
export default {"cardEvent":"styles_cardEvent__5AEGW","content":"styles_content__yOw7O","imgContainer":"styles_imgContainer__2A3vL"};